import { handleActions } from 'redux-actions';
import { EditorState } from '../types';
import {
  fetchGifs,
  fetchGifsSuccess,
  fetchGifsFailure,
} from '../actions/extension-gif';

export default handleActions<EditorState['extensionGif'], any>(
  {
    [`${fetchGifs}`]: (
      state,
      action: ReturnType<typeof fetchGifs>
    ) => ({
      ...state,
      fetching: true,
      search: action.payload.q,
      page: action.payload.pg,
    }),
    [`${fetchGifsSuccess}`]: (
      state,
      action: ReturnType<typeof fetchGifsSuccess>
    ) => ({
      ...state,
      fetching: false,
      items: (state.search.length > 0 && state.page > 0)
        ? state.items.concat(action.payload.gifs)
        : action.payload.gifs,
      hasMore: (state.search && (action.payload.gifs || []).length),
      page: state.page + 1,
      apiError: false,
    }),
    [`${fetchGifsFailure}`]: (
      state,
      action: ReturnType<typeof fetchGifsFailure>
    ) => ({
      ...state,
      fetching: false,
      apiError: true,
      hasMore: false,
    }),
  },
  {
    search: '',
    items: [],
    page: 0,
    fetching: false,
    hasMore: false,
    apiError: false,
  }
);
